export const GET_CITY_DEFINITIONS = "GET_CITY_DEFINITIONS"
export const GET_CITY_DEFINITIONS_SUCCESS = "GET_CITY_DEFINITIONS_SUCCESS"
export const GET_CITY_DEFINITIONS_FAIL = "GET_CITY_DEFINITIONS_FAIL"


export const ADD_CITY_DEFINITION = "ADD_CITY_DEFINITION"
export const ADD_CITY_DEFINITION_SUCCESS = "ADD_CITY_DEFINITION_SUCCESS"
export const ADD_CITY_DEFINITION_FAIL = "ADD_CITY_DEFINITION_FAIL"

export const UPDATE_CITY_DEFINITION = "UPDATE_CITY_DEFINITION"
export const UPDATE_CITY_DEFINITION_SUCCESS = "UPDATE_CITY_DEFINITION_SUCCESS"
export const UPDATE_CITY_DEFINITION_FAIL = "UPDATE_CITY_DEFINITION_FAIL"

export const DELETE_CITY_DEFINITION = "DELETE_CITY_DEFINITION"
export const DELETE_CITY_DEFINITION_SUCCESS = "DELETE_CITY_DEFINITION_SUCCESS"
export const DELETE_CITY_DEFINITION_FAIL = "DELETE_CITY_DEFINITION_FAIL"

export const API_ERROR = "API_ERROR"
